var _path, _path2, _path3, _g, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGw = function SvgGw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h220v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M220 0h420v240H220z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M220 240h420v240H220z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gw_svg__b",
    transform: "matrix(80 0 0 80 110 240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gw_svg__a",
    fill: "#000001",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw_svg__a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(72 110 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(144 110 240)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 110 240)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 110 240)"
  })));
};
export default SvgGw;